import { Component, OnInit } from '@angular/core';
import { BaseViewComponent } from '@app/views/base-view-component';

@Component({
  selector: 'app-customer-api-test',
  templateUrl: './customer-api-test.component.html',
  styleUrls: ['./customer-api-test.component.scss']
})
export class CustomerApiTestComponent implements OnInit {

  ngOnInit() {
  }

}
